var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 1000 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3557321,0,0,3.3557321,-1551.7864,-2007.0469)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5579399,0,0,2.5579399,884.90115,-11.427398)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-502.86126,-22.613497)",
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ff5f00",
    height: 56.599998,
    width: 31.5,
    y: 268.60001,
    x: 380.20001
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "m 382.2,296.9 c 0,-11.5 5.4,-21.7 13.7,-28.3 -6.1,-4.8 -13.8,-7.7 -22.2,-7.7 -19.9,0 -36,16.1 -36,36 0,19.9 16.1,36 36,36 8.4,0 16.1,-2.9 22.2,-7.7 -8.3,-6.5 -13.7,-16.8 -13.7,-28.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "m 454.2,296.9 c 0,19.9 -16.1,36 -36,36 -8.4,0 -16.1,-2.9 -22.2,-7.7 8.4,-6.6 13.7,-16.8 13.7,-28.3 0,-11.5 -5.4,-21.7 -13.7,-28.3 6.1,-4.8 13.8,-7.7 22.2,-7.7 19.9,0 36,16.2 36,36 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.3e0b19fc90c726a852c7030682696d30.svg";
export { ForwardRef as ReactComponent };